import * as animations from "../animations";
export default (({
  animation
}) => animations[animation]);
//# sourceMappingURL=animation.js.map